import Main from "./pages/main";
import Documentation from "./pages/documentation";
import Standalone from "./pages/standalone";
import About from "./pages/about";
import Status from "./pages/status";

export default [
  { path: "/", component: Main, name: "Home" },
  { path: "/documentation", component: Documentation, name: "Documentation" },
  { path: "/standalone", component: Standalone, name: "Standalone" },
  { path: "/about", component: About, name: "About" },
  { path: "/status/:jobId", component: Status, name: "Status", skip: true }
];



// WEBPACK FOOTER //
// ./src/routes.js